"use client";

import { useEffect, useMemo, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

import HelmetTags from "../../../../MainComponents/HelmetTags";
import useTable from "../../../../MainComponents/Hooks/useTable.jsx";

const AdminCorrection = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const academicTypeFromUrl = searchParams.get("type");
  const academicLevelFromUrl = searchParams.get("level");

  const [academicType, setAcademicType] = useState(
    academicTypeFromUrl || "national",
  );

  const [academiclevel, setAcademiclevel] = useState(
    academicLevelFromUrl || "11",
  );

  useEffect(() => {
    setSearchParams({
      type: academicType,
      level: academiclevel,
    });
  }, [academicType, academiclevel, setSearchParams]);

  const table = useTable(
    "corrections",
    "",
    "",
    academiclevel,
    "",
    academiclevel,
  );

  return (
    <section className="h-full w-full overflow-y-auto px-20 py-20 sm:px-10 ">
      <HelmetTags title="Correction | Mr.Ahmed Sabry" />

      <h2 className="mb-32 w-full text-4xl font-bold md:text-center">
        Correction
      </h2>

      <div className="mb-20 flex flex-col items-end gap-20">
        <div className="flex w-full gap-10 md:justify-center sm:flex-col-reverse sm:items-center">
          <button
            onClick={() => {
              setAcademicType("national");
              setAcademiclevel("11");
            }}
            className={`min-w-[200px] rounded-xl border-2 border-secondary p-4 font-semibold transition-all duration-300 hover:bg-light hover:text-secondary active:scale-90 ${
              academicType === "national" && "bg-secondary text-light"
            }`}
          >
            National
          </button>

          <button
            onClick={() => {
              setAcademicType("ig");
              setAcademiclevel("9");
            }}
            className={`min-w-[200px] rounded-xl border-2 border-secondary p-4 font-semibold transition-all duration-300 hover:bg-light hover:text-secondary active:scale-90 ${
              academicType === "ig" && "bg-secondary text-light"
            }`}
          >
            IG
          </button>
        </div>

        {academicType === "national" && (
          <div className="flex w-full gap-10 md:flex-col md:justify-center sm:items-center">
            <button
              onClick={() => setAcademiclevel("11")}
              className={`rounded-xl border-2 border-secondary p-4 font-semibold transition-all duration-300 hover:bg-light hover:text-secondary active:scale-90 ${
                academiclevel === "11" && "bg-secondary text-light"
              }`}
            >
              First preparatory
            </button>

            <button
              onClick={() => setAcademiclevel("22")}
              className={`rounded-xl border-2 border-secondary p-4 font-semibold transition-all duration-300 hover:bg-light hover:text-secondary active:scale-90 ${
                academiclevel === "22" && "bg-secondary text-light"
              }`}
            >
              Second preparatory
            </button>

            <button
              onClick={() => setAcademiclevel("33")}
              className={`rounded-xl border-2 border-secondary p-4 font-semibold transition-all duration-300 hover:bg-light hover:text-secondary active:scale-90 ${
                academiclevel === "33" && "bg-secondary text-light"
              }`}
            >
              Third Preparatory
            </button>

            <button
              onClick={() => setAcademiclevel("1")}
              className={`rounded-xl border-2 border-secondary p-4 font-semibold transition-all duration-300 hover:bg-light hover:text-secondary active:scale-90 ${
                academiclevel === "1" && "bg-secondary text-light"
              }`}
            >
              First Secondary
            </button>

            <button
              onClick={() => setAcademiclevel("2")}
              className={`rounded-xl border-2 border-secondary p-4 font-semibold transition-all duration-300 hover:bg-light hover:text-secondary active:scale-90 ${
                academiclevel === "2" && "bg-secondary text-light"
              }`}
            >
              Second Secondary
            </button>

            <button
              onClick={() => setAcademiclevel("3")}
              className={`rounded-xl border-2 border-secondary p-4 font-semibold transition-all duration-300 hover:bg-light hover:text-secondary active:scale-90 ${
                academiclevel === "3" && "bg-secondary text-light"
              }`}
            >
              Third Secondary
            </button>
          </div>
        )}

        {academicType === "ig" && (
          <div className="flex w-full gap-10 md:flex-col md:justify-center sm:items-center">
            <button
              onClick={() => setAcademiclevel("9")}
              className={`rounded-xl border-2 border-secondary p-4 font-semibold transition-all duration-300 hover:bg-light hover:text-secondary active:scale-90 ${
                academiclevel === "9" && "bg-secondary text-light"
              }`}
            >
              Pre-IG
            </button>

            <button
              onClick={() => setAcademiclevel("10")}
              className={`rounded-xl border-2 border-secondary p-4 font-semibold transition-all duration-300 hover:bg-light hover:text-secondary active:scale-90 ${
                academiclevel === "10" && "bg-secondary text-light"
              }`}
            >
              O-Level
            </button>

            <button
              onClick={() => setAcademiclevel("12")}
              className={`rounded-xl border-2 border-secondary p-4 font-semibold transition-all duration-300 hover:bg-light hover:text-secondary active:scale-90 ${
                academiclevel === "12" && "bg-secondary text-light"
              }`}
            >
              IAL
            </button>
          </div>
        )}
      </div>

      <div className="h-fit w-full">{table}</div>
    </section>
  );
};

export default AdminCorrection;